import { render, staticRenderFns } from "./JsonTrans.vue?vue&type=template&id=5dc9720e&scoped=true"
import script from "./JsonTrans.vue?vue&type=script&lang=js"
export * from "./JsonTrans.vue?vue&type=script&lang=js"
import style0 from "./JsonTrans.vue?vue&type=style&index=0&id=5dc9720e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc9720e",
  null
  
)

export default component.exports